export class CopyCarnetSrRequest {
    body: CopyCarnetSrBody = new CopyCarnetSrBody();
}

export class CopyCarnetSrBody {
    ProcessName: string = "DC Community Portal SR Process Wrapper WF";
    DCMethod: string = "COPY_ATA_SR";
    DCLoginName: string = "";
    DCLanguage: string = "ENU";
    DCToSRNumber: string = ""; // New SR Number which is created
    DCIncomingHierarchy: CopyCarnetDCIncomingHierarchy = new CopyCarnetDCIncomingHierarchy();
}

export class CopyCarnetDCIncomingHierarchy {
    MessageId: string = "";
    IntObjectName: string = "DC Community Portal SR Upsert IO";
    MessageType: string = "Integration Object";
    IntObjectFormat: string = "Siebel Hierarchical";
    "ListOfDC Community Portal SR Upsert IO": ListOfDCCommunityPortalSRUpsertIO =
        new ListOfDCCommunityPortalSRUpsertIO();
}

export class ListOfDCCommunityPortalSRUpsertIO {
    "DC Community Portal SR": DCCommunityPortalSR = new DCCommunityPortalSR();
}

export class DCCommunityPortalSR {
    CSN: string = "";
    "SR Type": string = "";
    "Sub Type": string = "";
    "SR Number": string = ""; 
}
